import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SuccessConfirmationSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SuccessConfirmationSVG;
